import { render } from "./chat-layout.vue?vue&type=template&id=44797269"
import script from "./chat-layout.vue?vue&type=script&lang=js"
export * from "./chat-layout.vue?vue&type=script&lang=js"

import "./chat-layout.vue?vue&type=style&index=0&id=44797269&lang=scss"
script.render = render

export default script